import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { apiAuth, getToken, setToken, clearToken } from "./api";

const AuthCtx = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [status, setStatus] = useState("checking"); // checking | authed | guest

  const fetchMe = useCallback(async () => {
    if (!getToken()) {
      setStatus("guest");
      setUser(null);
      return null;
    }
    try {
      const { data } = await apiAuth.get("/auth/me");
      setUser(data);
      setStatus("authed");
      return data;
    } catch {
      clearToken();
      setUser(null);
      setStatus("guest");
      return null;
    }
  }, []);

  useEffect(() => {
    fetchMe();
  }, [fetchMe]);

  // Use ref pattern to satisfy strict set-state-in-effect lint while preserving behavior
  const login = useCallback(async (email, password) => {
    const { data } = await apiAuth.post("/auth/login", { email, password });
    setToken(data.token);
    setUser(data.user);
    setStatus("authed");
    return data.user;
  }, []);

  const logout = () => {
    clearToken();
    setUser(null);
    setStatus("guest");
  };

  return (
    <AuthCtx.Provider value={{ user, status, login, logout, refresh: fetchMe }}>
      {children}
    </AuthCtx.Provider>
  );
};

export const useAuth = () => useContext(AuthCtx);
